import { render, staticRenderFns } from "./ResidentialIcon.vue?vue&type=template&id=a043cf86&"
import script from "./ResidentialIcon.vue?vue&type=script&lang=js&"
export * from "./ResidentialIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports